import Vue from "vue"
import Axios from "axios"

const actions = {
  // ////////////////////////////////////////////
  // SIDEBAR & UI UX
  // ////////////////////////////////////////////

  updateSidebarWidth({ commit }, width) {
    commit('UPDATE_SIDEBAR_WIDTH', width);
  },
  toggleContentOverlay({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY');
  },
  updateTheme({ commit }, val) {
    commit('UPDATE_THEME', val);
  },
  updateWindowWidth({ commit }, width) {
    commit('UPDATE_WINDOW_WIDTH', width);
  },
  updateHashPath({ commit }, hash) {
    commit('UPDATE_HASH_PATH', hash);
  },

  // ////////////////////////////////////////////
  // COMPONENT
  // ////////////////////////////////////////////

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  //  The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  async getAddressByZipcode({ state }, cep) {
    const { status, data, error } = await Axios.get(`${state.filooServer}cep/${cep}`)
      .catch((error) => error.response.data)

    if (error) {
      console.error(error)
    }

    if (data.data) {
      return status === 200 ? data.data : null
    }

    return status === 200 ? data : null
  },

  async getGoogleAddress({ state }, { cep, lat, lng }) {
    const url = [`key=${state.googleMapKey}`]

    if (cep) {
      url.push(`address=${cep}`)
    }
    if (lat && lng) {
      url.push(`latlng=${lat},${lng}`)
    }

    const { status, data } = await Axios.get(
      `${state.googleMapUrl}api/geocode/json?${url.join("&")}`
    )

    return status === 200 && data.status === "OK" ? data.results[0] : null
  },
  
  async getAllPlans({ state }) {
    const { status, data } = await Axios.get(
      `${state.filooServer}customerplan/all-plans`,
      { headers: { Authorization: Vue.prototype.$session.get("bearer") }}
    )

    return status === 200 ? data : []
  },

  async getSpecialties({ state }, parameters = {}) {
    const page = parameters.page || 0

    const { status, data } = await Axios.get(
      `${state.filooServer}specialty?sort=name&page=${page}`,
      { headers: { Authorization: Vue.prototype.$session.get("bearer") }}
    )

    return status === 200 ? data : []
  },

  async getSpecialtyById({ state }, id) {
    const { status, data } = await Axios.get(
      `${state.filooServer}specialty/${id}`,
      { headers: { Authorization: Vue.prototype.$session.get("bearer") }}
    )

    return status === 200 ? data : []
  },

  async setSpecialty({ state }, payload) {
    const { status } = await Axios.post(
      `${state.filooServer}specialty`,
      payload,
      { headers: { Authorization: Vue.prototype.$session.get("bearer") }}
    )

    return { success: status === 201 }
  },

  async updateSpecialty({ state }, payload) {
    const { status } = await Axios.put(
      `${state.filooServer}specialty`,
      payload,
      { headers: { Authorization: Vue.prototype.$session.get("bearer") }}
    )

    return { success: status === 204 }
  },

  async getCompanySignaturesList({ state }, companyId) {
    const { status, data } = await Axios.get(
      `${state.filooServer}company/customerplan/${companyId}?page=0&size=1000`,
      { headers: { Authorization: Vue.prototype.$session.get("bearer") }}
    )

    return status === 200 && data.numberOfElements ? data.content : []
  },

  async getCompanyUploadRegisters({ state }, page) {
    const { status, data } = await Axios.get(
      `${state.filooServer}company/upload-registers?page=${page}&size=10`,
      { headers: { Authorization: Vue.prototype.$session.get("bearer") }}
    )

    return status === 200 && data.numberOfElements
      ? data
      : ({ content: [], totalElements: 0, totalPages: 0 })
  },

  async getPlanServices({ state }) {
    const { status, data } = await Axios.get(
      `${state.filooServer}plan-services`,
      { headers: { Authorization: Vue.prototype.$session.get("bearer") }}
    )
      .catch((err) => console.error(err))

    return status === 200 ? data : null
  },

  async getPlanServiceById({ state }, id) {
    const { status, data } = await Axios.get(
      `${state.filooServer}plan-services/${id}`,
      { headers: { Authorization: Vue.prototype.$session.get("bearer") }}
    )
      .catch((err) => console.error(err))

    return status === 200 ? data : null
  },

  async createPlanService({ state }, payload) {
    const { status } = await Axios.post(
      `${state.filooServer}plan-services`,
      payload,
      { headers: { Authorization: Vue.prototype.$session.get("bearer") }}
    )

    return { success: status === 200 }
  },

  async updatePlanService({ state }, { id, payload }) {
    const { status } = await Axios.put(
      `${state.filooServer}plan-services/${id}`,
      payload,
      { headers: { Authorization: Vue.prototype.$session.get("bearer") }}
    )

    return { success: status === 200 }
  },

  async setPartnerLogo({ state }, { id, formData }) {
    const { status } = await Axios.post(
      `${state.filooServer}partner/${id}/logo`,
      formData,
      {
        headers: { Authorization: Vue.prototype.$session.get("bearer") },
        "Content-Type": "multipart/form-data",
      }
    )

    return { success: status === 200 }
  }
}

export default actions
